import { render, staticRenderFns } from "./WorkIconDashboard.vue?vue&type=template&id=e32871be"
import script from "./WorkIconDashboard.vue?vue&type=script&lang=js"
export * from "./WorkIconDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports